import { render, staticRenderFns } from "./PackageManager.vue?vue&type=template&id=e08bf9bc&"
import script from "./PackageManager.vue?vue&type=script&lang=js&"
export * from "./PackageManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageManager.vue"
export default component.exports